import { ErrorData } from 'onramp-pages/api';

export const isBinBlock = (error: ErrorData) => {
  return (
    Object.keys(error.details).includes('pspStatusCode') &&
    error.details.pspStatusCode === '57'
  );
};
